import React from "react";
import { Helmet } from "react-helmet-async";
import loadable from "@loadable/component";
import ErrorHandler from "../../../components/shared/with-error-handler";
import { FUNNEL_CONFIG } from "../../../utils/funnel/steps.desktop";
import { LEAD_FORM } from "../../../constants/app-constants";
import { SELL_ONLINE_STEP_KEY } from "../../../constants/sell-online-constant";
import GoogleMapScript from "../../../components/shared/googlemap-script";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import startViewTransition from "../../../utils/helpers/view-transition-api";
import { sendCustomGaEvents } from "../../../tracking";
import { trackingRepeatUser } from "./tracking";
import PropTypes from "prop-types";

const SellOnlineLeadStepContainer = loadable(() => import("../../../components/desktop/sell-online-lead-step-container"));

const Appointment = ({ setPageLoadingConnect, history }) => {
    const errorHandler = async (prevToken) => {
        await yieldToMain();
        startViewTransition({
            callback: () => {
                setPageLoadingConnect(true, "Whoo-hoo! It seems we have already inspected your car");
                history.push(`/inspection-complete/${prevToken}?token_type=lead_token`);
            }
        });
        await yieldToMain();
        sendCustomGaEvents({
            ...trackingRepeatUser,
            eventLabel: prevToken
        });

    };

    return (
        <React.Fragment>
            <Helmet>
                <title>Cars24 | Book an appointment for a car inspection</title>
                <meta name="ROBOTS" content="NOINDEX,FOLLOW" />
            </Helmet>
            <ErrorHandler>
                <GoogleMapScript />
                <SellOnlineLeadStepContainer errorHandler={errorHandler} manualCurrentStep={SELL_ONLINE_STEP_KEY.PRICE_ESTIMATE} stepsConfig={FUNNEL_CONFIG[LEAD_FORM.APPOINTMENT]} />
            </ErrorHandler>
        </React.Fragment>
    );
};

Appointment.propTypes = {
    setPageLoadingConnect: PropTypes.func,
    history: PropTypes.object
};

export default Appointment;
